import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Heading, Text, Button, useColorModeValue } from '@chakra-ui/react';

import { deleteUserApi } from 'features/users/users.api';
import ConfirmationPopup from 'components/popup/ConfirmationPopup';

const DeleteAccount = () => {
  const dispatch = useDispatch();
  const { userId, deleteUserStatus } = useSelector((state) => state.users);

  const bgCard = useColorModeValue('white', 'whiteAlpha.100');
  const textColor = useColorModeValue('gray.700', 'white');

  const [isPopupOpen, setPopupOpen] = useState(false);

  const handleDeleteAccount = () => {
    setPopupOpen(true);
  };

  const handleConfirm = () => {
    dispatch(deleteUserApi({ id: userId }));
    setPopupOpen(false);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  return (
    <Box
      bg={bgCard}
      p={6}
      mt={6}
      borderRadius="lg"
      boxShadow="sm"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        <Heading as="h3" size="lg" color={textColor}>
          Delete this account
        </Heading>
        <Text fontSize="sm" color="gray.500">
          Here you can permanently delete this account
        </Text>
      </Box>

      <Button
        colorScheme="red"
        variant="outline"
        w="200px"
        onClick={handleDeleteAccount}
        isLoading={deleteUserStatus === 'pending'}
      >
        Delete account
      </Button>

      <ConfirmationPopup
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        onConfirm={handleConfirm}
        title="Confirm Account Deletion"
        description="Are you sure you want to delete this account? This action cannot be undone."
        confirmButtonText="Yes, Delete"
        cancelButtonText="Cancel"
      />
    </Box>
  );
};

export default DeleteAccount;
